import React from 'react';
import { useMediaQueryContext } from '@fourthwall/components';
import { useVerifyDiscord } from '@modules/Dashboard/pages/Apps/pages/AppsDiscordVerification';
import { getBonus } from '../../utils';
import { Incentive } from '../Incentive';
export const DiscordIncentive = ({ incentive }) => {
    const { alreadyVerified, openVerificationLink } = useVerifyDiscord();
    const { tablet } = useMediaQueryContext();
    return (React.createElement(Incentive, { type: incentive.type, icon: "\uD83E\uDD16", label: "Join our Discord", isCompleted: incentive.isCompleted || alreadyVerified, bonus: getBonus(incentive.bonus), button: {
            label: tablet ? 'Join Discord' : 'Join',
            onClick: openVerificationLink,
        } }));
};
